import React from 'react'
import { Updater, fromJSX, Widget } from 'widgets-for-react'
import { ExpandBlock } from '../../blocksState'
import { ExpandBlockLayout } from './expandBlockLayout'
import { ExpandBlockState, expandBlockStateUpdaters } from './expandBlockState'

export const expandBlockWidget = (
  block: ExpandBlock,
  acceptVideoCookie: () => void
): Widget<Updater<ExpandBlockState>> =>
  fromJSX((setState) => (
    <ExpandBlockLayout
      {...block}
      acceptVideoCookie={acceptVideoCookie}
      expand={(item: number) => setState(expandBlockStateUpdaters.expandBlockItemUpdater(item))}
    />
  ))
